import { render } from "./NewServiceSelector.vue?vue&type=template&id=2ba348f5"
import script from "./NewServiceSelector.vue?vue&type=script&lang=js"
export * from "./NewServiceSelector.vue?vue&type=script&lang=js"

import "./NewServiceSelector.vue?vue&type=style&index=0&id=2ba348f5&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__